let interactionsArr = [];

function trackMenuClick(category, menuType) {
    // gtag('event', 'menu_click', {
    //     'variant': menuType,
    //     'category': category,
    //     'event_type': 'click'
    // });
    console.log('gtag-menu_click');
    console.log('gtag-variant: ' + menuType);
    console.log('gtag-category: ' + category);
    interactionsArr.push({
        'variant': menuType,
        'category': category,
        'event_type': 'click',
        'created_at': new Date().toISOString(),
    });
    sessionStorage.setItem('interactions', JSON.stringify(interactionsArr));
}

// Rastrear cliques em categorias
document.querySelectorAll('[menubtn]').forEach(link => {
    const menuType = document.getElementById('menu_variant').value;
    const category = link.getAttribute('menubtn');
    link.addEventListener('click', function(e) {
        trackMenuClick(category, menuType);
    });
});

window.addEventListener('pagehide', function() {
    let storedInteractions = JSON.parse(sessionStorage.getItem('interactions') || '[]');
    if (storedInteractions.length === 0) return;
    fetch($("#logMenuEvent").val(), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        body: JSON.stringify({ interactions: storedInteractions }),
        keepalive: true 
    }).then(() => {
        sessionStorage.removeItem('interactions');
    }).catch(error => console.error('Error logging menu events:', error));
});